import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect } from "react";
import { TabbedShowLayout, useRecordContext } from "react-admin";
import ElectionHeader from "../../components/ElectionHeader";
import { EditCandidateData } from "./EditCandidateData";
import { useElectionEventTallyStore } from "@/providers/ElectionEventTallyProvider";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
export var CandidateTabs = function () {
    var record = useRecordContext();
    var aliasRenderer = useAliasRenderer();
    var _a = useElectionEventTallyStore(), setCandidateIdFlag = _a.setCandidateIdFlag, setContestIdFlag = _a.setContestIdFlag, setElectionEventIdFlag = _a.setElectionEventIdFlag;
    useEffect(function () {
        if (record) {
            setCandidateIdFlag(record.id);
            setContestIdFlag(record.contest_id);
            setElectionEventIdFlag(record.election_event_id);
        }
    }, [record]);
    return (_jsxs(_Fragment, { children: [_jsx(ElectionHeader, { title: aliasRenderer(record) || "", subtitle: "candidateScreen.common.subtitle" }), _jsx(TabbedShowLayout, { children: _jsx(TabbedShowLayout.Tab, { label: "Data", children: _jsx(EditCandidateData, { record: record }) }) })] }));
};
